import { AfterViewInit, Component, OnInit,Input, Output, EventEmitter } from '@angular/core';
import tinymce from 'tinymce';
declare const $: any;
@Component({
  selector: 'app-tinyedneditor',
  templateUrl: './tinyedneditor.component.html',
  styleUrls: ['./tinyedneditor.component.css'],
})
export class TinyedneditorComponent implements OnInit, AfterViewInit {
  @Input() ActivityHistorylist: any;
  @Input() getquestionFilterlist: any;
  @Input() Questionlistresponse: any;
  @Input() QuestionMonthlyCount: any;
  @Input() QuestionStatusReport: any;
  @Input() ContentActivityHistorylist: any;
  @Input() getFilterlist: any;
  @Output() EditButton: EventEmitter<any> = new EventEmitter<any>();
  @Output() FilteredQuestionEditButton: EventEmitter<any> =
    new EventEmitter<any>();
  @Output() EditQuestion: EventEmitter<any> = new EventEmitter<any>();
  @Output() ContentEditButton: EventEmitter<any> = new EventEmitter<any>();
  @Output() StudymaterialEditButton: EventEmitter<any> =
    new EventEmitter<any>();
  @Output() StudymaterialStatus: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {
    console.log('ActivityHistorylist:', this.ActivityHistorylist);
    console.log('getquestionFilterlist:', this.getquestionFilterlist);
    console.log('Questionlistresponse:', this.Questionlistresponse);
    console.log('QuestionMonthlyCount:', this.QuestionMonthlyCount);
    console.log('QuestionStatusReport:', this.QuestionStatusReport);
    console.log('ContentActivityHistorylist:', this.ContentActivityHistorylist);
    console.log('getFilterlist:', this.getFilterlist);
  }
  ngAfterViewInit(): void {
    // $('#example').DataTable();
    $(document).ready(function () {
      $('#ActivityHistory').DataTable({
        destroy: true,
        columns: [
          { data: 'Question_Id' }, // index - 0
          { data: 'Topic' }, // index - 1
          { data: 'Question_Text' }, // index - 2
          { data: 'Question_Status_Type_Name' }, // index - 3
          { data: 'Created_By' }, // index - 4
          { data: 'Creation_Date' }, // index - 4
        ],
        columnDefs: [
          {
            targets: [2], // column index (start from 0)
            orderable: false, // set orderable false for selected columns
          },
        ],
      });
    });
    $(document).ready(function () {
      $('#getquestionFilter').DataTable({
        destroy: true,
        columns: [
          { data: 'Question_Id' }, // index - 0
          { data: 'Topic' }, // index - 1
          { data: 'Question_Text' }, // index - 2
          { data: 'Question_Status_Type_Name' }, // index - 3
          { data: 'Created_By' }, // index - 4
          { data: 'Creation_Date' }, // index - 4
        ],
        columnDefs: [
          {
            targets: [2], // column index (start from 0)
            orderable: false, // set orderable false for selected columns
          },
        ],
        
      });
    });
    $(document).ready(function () {
      $('#Questionlist').DataTable({
        destroy: true,
        columns: [
          { data: 'Question_Id' }, // index - 0
          { data: 'Translated_Question_Id' }, // index - 1
          { data: 'Question_Status_Type_Name' }, // index - 2
          { data: 'Question_Text' }, // index - 3
          { data: 'Allow_Translation_Ind' }, // index - 4
          { data: 'Created_By' }, // index - 4
          { data: 'Creation_Date' }, // index - 4
          { data: 'Created_By' }, // index - 4
          { data: 'Creation_Date' }, // index - 4
        ],
        columnDefs: [
          {
            targets: [3], // column index (start from 0)
            orderable: false, // set orderable false for selected columns
          },
        ],
      });
    });
    $(document).ready(function () {
      $('#QuestionCount').DataTable({
        destroy: true,
        columns: [
          { data: 'Year' },
          { data: 'Month' },
          { data: 'Name' },
          { data: 'Created' },
          { data: 'Updated' },
          { data: 'Reviewed' },
          { data: 'Approved' },
        ],
        columnDefs: [
          {
            targets: [2],
            orderable: false,
          },
        ],
      });
    });
    $(document).ready(function () {
      $('#QuestionDefer').DataTable({
        destroy: true,
        columns: [
          { data: '' },
          { data: 'Question_ID' },
          { data: 'Topic' },
          { data: 'Question_Status_Type_Name' },
          { data: 'Created_By' },
          { data: 'Creation_Date' },
        ],
        columnDefs: [
          {
            targets: [0, 2],
            orderable: false,
          },
        ],
      });
    });
    $(document).ready(function () {
      $('#ContentActivityHistory').DataTable({
        destroy: true,
      });
    });
    $(document).ready(function () {
      $('#ContentFilterActivityHistory').DataTable({
        destroy: true,
      });
    });
  }
  EditButton1(data: any) {
    this.EditButton.emit(data);
  }
  FilteredQuestionEditButton1(data: any) {
    this.FilteredQuestionEditButton.emit(data);
  }
  EditQuestion1(data: any) {
    this.EditQuestion.emit(data);
  }
  ContentEditButton1(data: any) {
    this.StudymaterialEditButton.emit(data);
  }
  clickstatuspopup1(data: any) {
    this.StudymaterialStatus.emit(data);
  }
}
